import { init } from "./init";

export const { api } = init({
  baseURL: "https://app.staging.nesto.ca/api",
  withHeaders: false,
});
